export const fr = {
  nav: {
    home: 'Accueil',
    services: 'Services',
    about: 'À Propos',
    portfolio: 'Portfolio',
    contact: 'Contact',
    getStarted: 'Commencer',
  },

  hero: {
    tagline: 'AGENCE CRÉATIVE',
    title: 'L\'Innovation Rencontre',
    titleHighlight: 'L\'Inspiration',
    subtitle: 'Nous créons des expériences marketing audacieuses et inoubliables.',
    cta: 'Démarrer Votre Projet',
    watchVideo: 'Voir la Vidéo',
    servicesButton: 'explorer les services',
    scrollText: 'Faites défiler pour explorer',
  },

  services: {
    tag: 'CE QUE NOUS FAISONS',
    title: 'Nos',
    titleHighlight: 'Services',
    subtitle: 'Solutions créatives complètes pour élever votre marque.',
    
    items: [
      {
        icon: '🎨',
        title: 'Branding',
        description: 'Créer une identité de marque mémorable.',
      },
      {
        icon: '📢',
        title: 'Publicité',
        description: 'Campagnes stratégiques qui capturent l\'attention.',
      },
      {
        icon: '✏️',
        title: 'Design',
        description: 'Designs visuels époustouflants.',
      },
      {
        icon: '🌐',
        title: 'Marketing Digital',
        description: 'Stratégies basées sur les données.',
      },
      {
        icon: '🎬',
        title: 'Production Vidéo',
        description: 'Production vidéo professionnelle.',
      },
      {
        icon: '💻',
        title: 'Développement Web',
        description: 'Sites web personnalisés et réactifs.',
      },
      {
        icon: '📱',
        title: 'Applications Mobiles',
        description: 'Applications mobiles intuitives.',
      },
    ],
  },

  about: {
    tag: 'À PROPOS',
    title: 'Pourquoi Choisir',
    titleHighlight: 'Orvin',
    subtitle: 'Nous sommes une équipe de créatifs passionnés.',
    
    stats: [
      { number: 78, label: 'Projets Terminés', suffix: '+' },
      { number: 98, label: 'Satisfaction Client', suffix: '%' },
      { number: 4, label: 'Membres d\'Équipe', suffix: '+' },
      { number: 5, label: 'Années d\'Expérience', suffix: '' },
    ],

    features: [
      {
        title: 'Excellence Créative',
        description: 'Équipe créative primée.',
      },
      {
        title: 'Approche Stratégique',
        description: 'Stratégies basées sur les données.',
      },
      {
        title: 'Centré sur le Client',
        description: 'Votre succès est notre priorité.',
      },
    ],
  },

  portfolio: {
    tag: 'NOTRE TRAVAIL',
    title: 'Projets',
    titleHighlight: 'En Vedette',
    subtitle: 'Explorez notre portfolio de projets réussis.',
    close:'fermer',
    categories: {
      all: 'Tous les Projets',
      branding: 'Branding',
      webDesign: 'Web Design',
      marketing: 'Marketing',
      appDesign: 'Design d\'App',
      video: 'Vidéo',
      design: 'Design',
    },

    viewProject: 'Voir le Projet',
    featured: 'En Vedette',
    client: 'Client',
    year: 'Année',
    viewLive: 'Voir le Projet Live',
  },

  contact: {
    tag: 'CONTACTEZ-NOUS',
    title: 'Créons Quelque Chose de',
    titleHighlight: 'Extraordinaire',
    subtitle: 'Prêt à faire passer votre marque au niveau supérieur?',
    
    form: {
      namePlaceholder: 'Votre Nom *',
      emailPlaceholder: 'Votre Email *',
      subjectPlaceholder: 'Sujet (Optionnel)',
      messagePlaceholder: 'Parlez-nous de votre projet... *',
      sendButton: 'Envoyer le Message 🚀',
      sending: 'Envoi...',
      requiredNote: '* Champs obligatoires | Nous répondrons sous 24 heures',
    },

    info: {
      email: 'Email',
      phone: 'Téléphone',
      location: 'Emplacement',
    },

    success: {
      title: 'Message Envoyé avec Succès! 🎉',
      message: 'Nous avons reçu votre message. Nous vous recontacterons sous 24 heures!',
    },

    errors: {
      nameRequired: 'Le nom doit contenir au moins 2 caractères',
      emailInvalid: 'Veuillez entrer une adresse email valide',
      messageRequired: 'Le message doit contenir au moins 10 caractères',
      subjectTooLong: 'Le sujet doit faire moins de 100 caractères',
      fixErrors: 'Veuillez corriger les erreurs dans le formulaire',
      sendFailed: 'Quelque chose s\'est mal passé. Veuillez réessayer.',
    },
  },

  footer: {
    tagline: 'L\'innovation rencontre l\'inspiration',
    about: 'Nous sommes une agence créative dédiée aux expériences marketing inoubliables.',
    quickLinks: 'Liens Rapides',
    services: 'Services',
    followUs: 'Suivez-Nous',
    copyright: '© 2026 Orvin Creative Agency. Tous droits réservés.',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions d\'Utilisation',
    craftedWith: 'Fabriqué avec passion',

  },
};

